<template>

  <div class="mydialog" v-if="myShow">
    <div class="mydialog-voerlay">
      <div class="ReportFileModel">
        <div class="sava-header">
          <span style="margin-left: 20px">举报</span>
          <img style="width: 20px;margin-right: 20px" src="@/assets/images/share/close.png"
               @click="handleClose">
        </div>
        <div style="width: 520px;height: 500px;">
          <h4><span style="color: red">*</span>内容违规</h4>
          <el-radio-group v-model="reportRadio"
                          style="height: 86px;margin-left: 30px;margin-top: 10px;">
            <el-radio :label="1" style="width: 95px">内容质量差</el-radio>
            <el-radio :label="2" style="width: 85px">标题夸张</el-radio>
            <el-radio :label="3" style="width: 85px">内容不实</el-radio>
            <el-radio :label="4" style="width: 85px">视频播放问题</el-radio>
            <el-radio :label="5" style="width: 95px">图片显示问题</el-radio>
            <el-radio :label="6" style="width: 85px">低俗色情</el-radio>
            <el-radio :label="7" style="width: 85px">欺诈诱导</el-radio>
            <el-radio :label="8" style="width: 85px">其他问题</el-radio>
          </el-radio-group>
          <h4>侵犯权益</h4>
          <div>
            <el-checkbox-group v-model="reportCheckBox"
                               style="margin-top: 12px;margin-left: 12px;margin-bottom: 12px">
              <el-checkbox label="1">抄袭我的作品</el-checkbox>
              <el-checkbox label="2">侵犯名誉商誉</el-checkbox>
              <el-checkbox label="3">侵犯肖像权</el-checkbox>
              <el-checkbox label="4">侵犯隐私权</el-checkbox>
            </el-checkbox-group>
            <h4>举报描述</h4>
            <el-input style="margin-top: 20px;width: 490px;margin-left: 12px;margin-bottom: 20px;"
                      v-model="reportReason"
                      maxlength="200"
                      placeholder="请描述你遇到的问题"
                      show-word-limit
                      type="textarea"
                      rows="3"
                      resize="none"
            />
            <h4>证明材料</h4>
            <div style="display: flex;flex-direction: column">
              <van-uploader v-model="fileList" multiple :max-count="3" :before-read="beforeRead"
                            :preview-full-image="false">
                <div class="upload-file">
                  <img src="@/assets/images/share/icon_co_add.png" class="upload-file-icon">
                  <span class="upload-file-page">最多3张</span>
                </div>
              </van-uploader>
              <span style="font-size: 13px;color: gray;margin-left: 16px;margin-top: 10px">*文件格式为png、jpg、jpeg、gif、bmp,且大小不超过15MB</span>
            </div>
          </div>
        </div>
        <button @click="PcreportFile()"
                :class="reportRadio=='' ? 'before-report' : 'after-report'">
          提交
        </button>
      </div>
    </div>
  </div>

</template>
<script>
import {reactive, toRefs, watch} from "vue";
import {ElMessage} from "element-plus";

export default {
  name: "PcReportModel",
  props: {
    Reportdialog: {
      type: Boolean,
      require: false,
      default: () => {
        return false
      }
    }
  },
  emits: ['PcReportcloseModel', 'PcReport'],
  setup(props, context) {

    let data = reactive({
      myShow: false,
      reportRadio: '',
      reportCheckBox: [],
      reportReason: '',
      fileList: [],
    })

    watch(
        () => props.Reportdialog,
        (newValue) => {
          data.myShow = newValue
        },
        {immediate: true}
    )

    function handleClose() {
      data.myShow = false
      context.emit('PcReportcloseModel')
    }

    const beforeRead = (file) => {
      if (file.size > 15728640) {
        ElMessage({
          message: '文件大小超过限制',
          type: 'warning',
          center: 'center'
        })
      }
      if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/jpg' && file.type != 'image/gif' && file.type != 'image/bmp') {
        ElMessage({
          message: '格式错误',
          type: 'warning',
          center: 'center'
        })
        return false;
      }
      return true;
    }

    function PcreportFile() {
      if (data.reportRadio) {
        let formData = new FormData()
        for (let i = 0; i < data.fileList.length; i++) {
          formData.append('img' + (i + 1), data.fileList[i].file)
        }
        let profitType = ''
        if (data.reportCheckBox.length > 0) {
          profitType = data.reportCheckBox.join(',')
        }
        context.emit('PcReport', {
          formData: formData,
          profitType: profitType,
          reportRadio: data.reportRadio,
          reportReason: data.reportReason
        })
      }
    }

    return {
      handleClose,
      beforeRead,
      PcreportFile,
      ...toRefs(data)
    }
  }
}
</script>
<style scoped>
.mydialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  height: 100%;
  overflow: auto;
}

.mydialog-voerlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  overflow: auto;
}

.sava-header {
  height: 60px;
  width: 100%;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.before-report {
  border: none;
  outline: none;
  width: 400px;
  height: 50px;
  border-radius: 20px;
  margin-top: 38px;
  cursor: pointer;
  color: #0982FE;
  background-color: #DAECFF;
}

.after-report {
  border: none;
  outline: none;
  width: 400px;
  height: 50px;
  background-color: #0982FE;
  border-radius: 20px;
  margin-top: 38px;
  color: white;
  cursor: pointer;
}

.ReportFileModel {
  width: 600px;
  height: 670px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 20px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
}

.upload-file {
  margin-top: 10px;
  width: 80px;
  height: 80px;
  background-color: #F7F8FA;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.upload-file-icon {
  width: 35px;
}

.upload-file-page {
  color: #B4B6C0;
  font-size: 11px;
}


</style>
